export default __webpack_public_path__ + "static/media/437.638e3995.png";